<template>
  <div class="tab-button-container">
    <label class="label">{{label}}</label>
    <button v-if="showAll"
      :class="{ active: currentTab === null }"
      @click="handleTabClick(null)"
    >
      全部
    </button>
    <button
      v-for="(tab, index) in tabs"
      :key="index"
      :class="{ active: currentTab === tab.id }"
      @click="handleTabClick(tab.id)"
    >
      {{ tab[name] ? tab[name] : tab.name }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'tabButton',
  props: {
    // 接收传入的 tab 列表，每个 tab 是一个对象，包含 label 属性
    tabs: {
      type: Array,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: ''
    },
    // 初始选中的 tab 索引
    initialTab: {
      type: [Number, String],
      default: null
    },
    // 初始选中的 tab 索引
    showAll: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    initialTab (newVal) {
      this.currentTab = newVal;
    }
  },
  data() {
    return {
      // 当前选中的 tab 索引
      currentTab: this.initialTab,
      currentProp: this.prop
    };
  },
  methods: {
    // 处理 tab 点击事件
    handleTabClick(tab) {
      this.currentTab = tab;
      // 触发自定义事件，通知父组件 tab 切换
      this.$emit('tab-change', {tab, prop: this.prop});
    }
  }
};
</script>

<style scoped>
.tab-button-container {
  display: flex;
}
button {
  padding: 8px 16px;
  margin-right: 10px;
  border-radius: 3px;
  border: none;
  background-color: #f0f0f0;
  cursor: pointer;
}

button.active {
  background-color: #007bff;
  color: white;
}
.tab-button-container {
  text-align: left;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/tabButton.vue